<template>
	<div class="header" :class="parentDynClass">
		<div
			class="logo"
			v-bind:class="{ openProductList: openProductList }"
			v-if="logo && logo != 'undefined'"
		>
			<img :src="logo" />
		</div>
		<div class="links" v-bind:class="{ openProductList: openProductList }">
			<a
				class="link"
				v-if="!(userType == 16)"
				@click="displayPBX ? '' : alert($event, 'serviceUnavailable')"
				v-bind:class="{ active: isPBXActive }"
				href="#/"
				><i
					class="fa-fw fa fa-volume-control-phone fa-2x"
					aria-hidden="true"
				></i
				><span class="caption">PBX</span></a
			>
			<a
				class="link"
				v-if="!(userType == 16)"
				v-bind:class="{ active: isCallCenterActive }"
				@click="
					displayCallCenter ? '' : alert($event, 'serviceUnavailable')
				"
				href="#/callcenter/"
				><i class="fa-fw fas fa-headset fa-2x" aria-hidden="true"></i
				><span class="caption">Call Center</span></a
			>
			<a
				class="link"
				v-if="!(userType == 16)"
				v-bind:class="{ active: isDialerActive }"
				@click="
					displayDialer ? '' : alert($event, 'serviceUnavailable')
				"
				href="#/dashboard/"
				><i class="fa-fw far fa-chart-bar fa-2x" aria-hidden="true"></i
				><span class="caption">Dialer</span></a
			>
			<a
				class="link"
				v-if="displayCRM"
				v-bind:class="{ active: isCRMActive }"
				href="#/crm/"
				><i class="fa-fw fas fa-users fa-2x" aria-hidden="true"></i
				><span class="caption">CRM</span></a
			>
			<div class="userinfo" :class="{'marginBottom':  buttonsCount == 0}" >
				<b-dropdown variant="link" class="userMenuButton">
					<template v-slot:button-content>
						<span class="activeUser"
							><i
								class="fas fa-caret-down"
								aria-hidden="true"
							/><i
								class="fa fa-user user-icon"
								aria-hidden="true"
							/>{{ username }}</span
						>
					</template>
					<b-dropdown-item
						href="#/commerce/customers/list/?own=1"
						v-if="isPBXActive"
						>Customer list</b-dropdown-item
					>
					<b-dropdown-item
						href="#/dashboard/user-list"
						v-if="isDialerActive"
						>User list</b-dropdown-item
					>
					<div class="scroll-down-users">
						<b-dropdown-item
							class="link-s"
							v-for="(user, index) in loginHistoryAfterFilter()"
							v-bind:key="index"
							href="#/dashboard/user-list"
							@click.prevent.stop="
								goToHistoryUser(user.raw.historyIndex);
								return false;
							"
						>
							<i class="fa fa-arrow-right" aria-hidden="true"></i
							><span>{{ user.label }}</span>
						</b-dropdown-item>
					</div>
					<b-dropdown-item @click="logout()">Logout</b-dropdown-item>
				</b-dropdown>
			</div>
		</div>
		<div
			class="product_button"
			v-bind:class="{ openProductList: openProductList, 'displayNone': buttonsCount == 0 }"
			@click="openProductList = !openProductList"
		>
			<i
				:class="productListButtonClass"
				class="fas fa-grip-horizontal toggleProductList"
			/>
		</div>
		<div class="space" />
		<agent-toolbar
			class="agentToolbar"
			v-if="displayToolbar"
			:enable-crm="displayCRM"
			@socketCreated="setScoket"
		/>
		<div
			v-if="!isCRMActive && !buttonsCount == 0"
			v-bind:class="{ openProductList: openProductList }"
			class="menu_button"
		>
			<a href="#" @click.stop.prevent="toggleMobileMenu()"
				><span class="fa fa-bars"></span
			></a>
		</div>
	</div>
</template>

<script>
import agentToolbar from "../AgentToolbar/App.vue";
import consts from "../consts.js";
import {EventBus} from "../event-bus.js";
export default {
	name: "Header",
	components: {agentToolbar},
	data: () => ({openUserMenu: false, openProductList: false, socket: null}),
	props: ["logo", "userType", "activeApps", "username", "loginHistory"],
	mounted() {
		if (this.buttonsCount == 0) {
			this.openProductList = true;
		}
	},
	methods: {
		setScoket(socket) {
			this.socket = socket;
		},
		alert(e, text) {
			if (text) {
				e.preventDefault();
				alert(this.$t(text));
			}
		},
		toggleMobileMenu() {
			this.$emit("toggleMobileMenu");
		},
		goToHistoryUser(index) {
			EventBus.$emit("goToHistoryUser", index);
		},
		logout() {
			if (this.socket) {
				this.socket.disconnect();
			}
			EventBus.$emit("USER_LOGOFF");
			let logOutUrl
				= window.location.hash == "#/empty"
					? "#/login/toolbar"
					: "#/login";
			window.location.href = logOutUrl;
			// if(history.location.pathname.indexOf("/login") === -1) history.go("/login/");
		},
		loginHistoryAfterFilter() {
			let filterArray = [];
			if (this.loginHistory.length < 1) {
				filterArray = this.loginHistory.filter((item, index) => {
					return index != 0;
				});
				return filterArray;
			}
			let start = 0;
			filterArray = this.loginHistory.sort((a, b) => {
				if (start === 0) {
					start++;
					return 0;
				}
				return a.label.localeCompare(b.label);
			});
			return filterArray;
		}
	},
	computed: {
		displayCallCenter() {
			return consts.PRODUCT.is(consts.PRODUCT.CALLCENTER, this.userType);
		},
		displayDialer() {
			return consts.PRODUCT.is(consts.PRODUCT.DIALER, this.userType);
		},
		displayPBX() {
			return consts.PRODUCT.is(consts.PRODUCT.PBX, this.userType);
		},
		displayCRM() {
			return consts.PRODUCT.is(consts.PRODUCT.CRM, this.userType);
		},
		displayToolbar() {
			return (
				consts.PRODUCT.is(consts.PRODUCT.TOOLBAR, this.userType)
				|| consts.PRODUCT.is(consts.PRODUCT.CRM, this.userType)
			);
		},
		buttonsCount() {
			return [
				this.displayCallCenter,
				this.displayDialer,
				this.displayPBX,
				this.displayCRM
			].filter((f) => f === true).length;
		},
		productListButtonClass() {
			return !this.openProductList ? "fa-grip-horizontal" : "fa-times";
		},
		parentDynClass() {
			let classes = ["btns" + this.buttonsCount];
			if (this.openProductList) {
				classes.push("openProductListWrapper");
			}
			return classes.join(" ");
		},
		isCallCenterActive() {
			return this.activeApps.includes("callcenter");
		},
		isDialerActive(name) {
			return this.activeApps.includes("dialer");
		},
		isPBXActive(name) {
			return this.activeApps.includes("pbx");
		},
		isCRMActive(name) {
			return this.activeApps.includes("crm");
		}
	}
};
</script>

<style lang="scss">
@import "@/styles/_vars.scss";
.marginBottom {
   margin-bottom: 20%;
}
.header {
	font-size: 14px; // box-shadow: 0px 0 10px 0px black;
	position: fixed;
	left: 0;
	top: 0;
	height: $header_height;
	background-color: $header-color;
	right: 0;
	display: flex;
	align-items: center;
	align-content: flex-start;
	z-index: 1000;
	.userinfo {
		padding: 0 10px;
		color: white;
		text-decoration: none;
		position: relative;
		ul li {
			color: #000000;
		}
		ul {
			min-width: 220px;
		}
		.btn-link.dropdown-toggle {
			.activeUser {
				cursor: pointer;
				color: white;
			}
		}
		.btn.dropdown-toggle.btn-link:hover {
			background-color: hsla(0, 0%, 100%, 0.13);
		}
		align-self: flex-end;
	}
	.links {
		align-self: stretch;
		display: flex;
		align-items: flex-end;
		align-content: flex-start;
		align-items: stretch; //flex-grow: 1;
	}
	.link {
		@media screen and (max-width: 767px) {
			.caption {
				font-size: 8px;
				line-height: 1em;
				display: none;
			} // align-self: stretch;
			flex-direction: column;
			width: auto;
			font-size: 1em;
			padding: 0 5px;
		}
		@media screen and (min-width: 768px) {
			i {
				padding-inline-end: 5px;
			}
			padding: 0 10px;
		}
		border-right: 1px solid #fff6;
		&:first-child {
			border-left: 1px solid #fff6;
		}
		outline: 0px;
		/* width: 7em; */
		flex: 1; // background-color: #FFFFFF1C;
		padding-bottom: 5px;
		padding-top: 5px;
		line-height: 1.2em;
		text-align: center;
		justify-content: center; //a {
		&:hover {
			background-color: #ffffff22;
		}
		color: white;
		font-size: 150%;
		text-decoration: none;
		display: flex;
		align-items: center;
		.caption {
			font-weight: bold;
		}
		/* &:hover .caption{text-decoration: underline;} */
		//}
		&.active {
			// margin-bottom: -10px; padding-bottom: 10px;
			// box-shadow: 0 0 15px white;
			border-radius: 1px 1px 0 0;
			background-color: $body-color; //a {
			color: $header-color;
			&:hover {
				.caption {
					text-decoration: none;
				}
				cursor: default;
			} //}
		}
		margin: 3px 0;
	}
	.logo {
		// text-align: center;
		display: flex;
		justify-content: center;
		/* align horizontal */
		align-items: center;
		/* align vertical */
		padding: 0 15px;
		img {
			// max-width: 100%;
			max-height: 5.5em;
		}
	}
	.userinfo {
		.backuser a {
			color: white;
			text-decoration: underline;
			&:hover {
				text-decoration: none;
			}
		}
		.user-icon {
			padding: 0;
			padding-inline-end: 0.5em;
		}
	}
	@media screen and (max-width: 767px) {
		.links {
			order: 1;
			flex: 0;
			flex-basis: 5%;
			display: none;
			&.openProductList {
				display: flex;
			}
		}
		.logo {
			order: 2;
			flex-grow: 1;
			flex-basis: 60%;
			&.openProductList {
				display: none;
			}
		}
		.menu_button {
			order: 3;
			flex-basis: 5%;
		}
		.space {
			display: none;
		}
		.toggleProductList {
			display: unset;
		}
		.dropdown-menu {
			left: unset;
			right: 0px;
		}
	}
}

.displayNone {
  display: none!important;
}
.product_button {
	display: none;
	@media screen and (max-width: 767px) {
		display: inherit;
		margin-inline-start: 15px;
		margin-inline-end: 15px;
		font-size: 3em;
		color: white !important;
	}
}

.menu_button {
	display: none;
	@media screen and (max-width: 767px) {
		display: inherit;
		margin-inline-end: 15px;
		margin-inline-start: auto;
		font-size: 3em;
		a {
			color: white !important;
		}
		&.openProductList {
			display: none;
		}
	}
}

@media screen and (max-width: 767px) {
	.openProductListWrapper {
		justify-content: space-between;
		flex-direction: row-reverse;
	}
}

.scroll-down-users {
	display: flex;
	flex-direction: column;
	max-height: 200px;
	width: 100%;
	overflow-y: auto;
	.dropdown-item {
		color: #000000;
		width: 100%;
		font-size: 1.2rem;
		display: flex;
		span {
			width: 100%;
			margin: 0;
			padding: 0;
		}
		i {
			width: 10%;
		}
		&:hover {
			background: rgba($color: black, $alpha: 0.3);
		}
	}
}

.space {
	flex-grow: 1;
}

.agentToolbar {
	align-self: center;
	@media screen and (max-width: 767px) {
		display: none;
	}
}

// .toggleProductList {display: none;}
</style>
